export default __webpack_public_path__ + "static/Plots0063-c921aa58f95c7beb79d1784691efd361.jpg";